import Papa from 'papaparse';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { ReportFilters, ReportKind } from './types';
import type { ReportData } from './useReports';

const fmtBrl = (n: number) => n.toFixed(2).replace('.', ',');

interface Input {
  kind: ReportKind;
  filters: ReportFilters;
  data: ReportData;
}

export function exportReportCsv({ kind, filters, data }: Input): void {
  const rows = data.rows.map((r) => {
    const dateForRow =
      kind === 'paid' || kind === 'received' ? (r.paymentDate ?? r.dueDate) : r.dueDate;
    return {
      Data: format(dateForRow, 'dd/MM/yyyy', { locale: ptBR }),
      Descrição: r.description,
      Contraparte: r.counterpartyName ?? '',
      Conta: r.accountName,
      Categoria:
        r.categorySplits && r.categorySplits.length > 0
          ? `Múltiplas (${r.categorySplits.length})`
          : r.categoryName,
      'Centro de Custo': r.costCenterName ?? '',
      Status: r.status === 'completed' ? 'Pago' : r.status === 'pending' ? 'Pendente' : 'Vencido',
      Principal: fmtBrl(Number(r.amount)),
      Multa: fmtBrl(Number(r.fine ?? 0)),
      Juros: fmtBrl(Number(r.interest ?? 0)),
      Valor: fmtBrl(Number(r.amount) + Number(r.interest ?? 0) + Number(r.fine ?? 0)),
    };
  });

  const csv = Papa.unparse(rows, { delimiter: ';' });
  const bom = '﻿';
  const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${kind}-${format(filters.fromDate, 'yyyy-MM-dd')}-a-${format(
    filters.toDate,
    'yyyy-MM-dd',
  )}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
